import { onMounted, onUnmounted } from 'vue';
import isEventNotInsideElement from '@src/utils/isEventNotInsideElement';

export function useClickOutside(elRef, handler, options = { bubble: false }) {
  const listener = (e) => {
    const el = elRef.value;
    if (!el) return;
    if (isEventNotInsideElement(el, e, options)) {
      handler(e);
    }
  };

  onMounted(() => {
    document.addEventListener('click', listener);
  });

  onUnmounted(() => {
    document.removeEventListener('click', listener);
  });
}
